import { Text, View } from '@applane/react-core-components';
import React from 'react';
import { Form } from '../../../app-components/form/Form';
import { showAllDetailsUri } from '../../../Queries/uciReportQuery';
import vars from '../../../theme/vars';
const modifyDateView = (value) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  const d = new Date(value);
  const day = d.getDate();
  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();
  return `${month} ${day} ${year}`;
};
const printRange = (ele) => {
  const eleArr = ele.split('-');
  return `${'$ ' + Math.round(eleArr[0]) + ' - $ ' + Math.round(eleArr[1])}`;
};

const addDollar = (ele) => {
  return `$ ${ele}`;
};

const addPercent = (ele) => {
  return `${ele} %`;
};
const checkField = ({
  navigation,
  fieldName,
  isDate = false,
  isPrice = false,
  isPercent = false,
  isRange = false,
}) => {
  const ele = navigation?.state?.params?.item[fieldName];
  if (ele) {
    if (isDate) {
      return (
        <Text
          style={{
            fontFamily: 'Mulish-Regular',
            letterSpacing: '0em',
            fontSize: 20,
            textAlign: 'left',
            color: 'black',
          }}>
          {modifyDateView(ele)}
        </Text>
      );
    } else if (isPrice) {
      return (
        <Text
          style={{
            fontFamily: 'Mulish-Regular',
            letterSpacing: '0em',
            fontSize: 20,
            textAlign: 'left',
            color: 'black',
          }}>
          {addDollar(ele)}
        </Text>
      );
    } else if (isPercent) {
      return (
        <Text
          style={{
            fontFamily: 'Mulish-Regular',
            letterSpacing: '0em',
            fontSize: 20,
            textAlign: 'left',
            color: 'black',
          }}>
          {addPercent(ele)}
        </Text>
      );
    } else if (isRange) {
      return (
        <Text
          style={{
            fontFamily: 'Mulish-Regular',
            letterSpacing: '0em',
            fontSize: 20,
            textAlign: 'left',
            color: 'black',
          }}>
          {printRange(ele)}
        </Text>
      );
    } else {
      return (
        <Text
          style={{
            fontFamily: 'Mulish-Regular',
            letterSpacing: '0em',
            fontSize: 20,
            textAlign: 'left',
            color: 'black',
          }}>
          {ele}
        </Text>
      );
    }
  } else {
    return (
      <Text
        style={{
          fontFamily: 'Mulish-Regular',
          letterSpacing: '0em',
          fontSize: 20,
          textAlign: 'left',
          color: 'grey',
        }}>
        N.A.
      </Text>
    );
  }
};
const PrintReport = (props) => {
  // const { navigation } = props;
  // const componentRef = useRef();
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  //   onAfterPrint: () => navigation.pop(),
  // });
  return (
    <View
    // onMouseOver={() => {
    //   console.log('\n\n----------FORM MOUSE OVER -----------------\n\n');
    //   //handlePrint;
    // }}
    // onMouseOver={handlePrint}
    //style={{ border: '1px solid red' }}
    >
      <Form
        type="standard"
        uri={showAllDetailsUri}
        closeView={1}
        fieldContainer="topLabel"
        lg={{
          formGroups: [
            //appraisal details section
            {
              columnsPerRow: 3,
              fieldVariant: 'filled',
              label: 'Appraisal Details',
              labelStyle: {
                ...vars.headings.h8,
                color: vars.colors.grey.color2,
                textTransform: 'uppercase',
              },
              groupsContainerStyle: {
                borderTop: '1px solid' + vars.colors.grey.color2,
              },
              groups: [
                {
                  columns: [
                    {
                      type: 'text',
                      label: 'Repair Order #',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'repairOrderNumber',
                        }),
                    },
                    {
                      type: 'date',
                      label: 'Repair Order Open Date',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'openDate',
                          isDate: true,
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Price Range',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'finalrange',
                          isRange: true,
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Vehicle Market Base Price',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'rmbp',
                          isPrice: true,
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Spread',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'ruleSpread',
                          isPercent: true,
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Enhancement',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'ruleEnhancement',
                          isPercent: true,
                        }),
                    },
                  ],
                },
              ],
            },
            //dealer details section
            {
              columnsPerRow: 3,
              fieldVariant: 'filled',
              label: 'Dealer Details',
              labelStyle: {
                ...vars.headings.h8,
                color: vars.colors.grey.color2,
                textTransform: 'uppercase',
              },
              groupsContainerStyle: {
                borderTop: '1px solid' + vars.colors.grey.color2,
              },
              groups: [
                {
                  columns: [
                    {
                      type: 'text',
                      label: 'Dealer Management System',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'dealerDMS',
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Dealer Name',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'dealerName',
                        }),
                    },
                  ],
                },
              ],
            },
            //customer details section
            {
              columnsPerRow: 3,
              fieldVariant: 'filled',
              label: 'Customer',
              labelStyle: {
                ...vars.headings.h8,
                color: vars.colors.grey.color2,
                textTransform: 'uppercase',
              },
              groupsContainerStyle: {
                borderTop: '1px solid' + vars.colors.grey.color2,
              },
              groups: [
                {
                  columns: [
                    {
                      type: 'text',
                      label: 'Name',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'customerName',
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Email',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'customerEmail',
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Contact Number',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'customerContactNumber',
                        }),
                    },
                  ],
                },
              ],
            },
            //vehicle details section
            {
              columnsPerRow: 3,
              fieldVariant: 'filled',
              label: 'Vehicle Details',
              labelStyle: {
                ...vars.headings.h8,
                color: vars.colors.grey.color2,
                textTransform: 'uppercase',
              },
              groupsContainerStyle: {
                borderTop: '1px solid' + vars.colors.grey.color2,
              },
              groups: [
                {
                  columns: [
                    {
                      type: 'text',
                      label: 'Vehicle VIN',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'vin',
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Vehicle Mileage',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'mileage',
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Vehicle Model',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'model',
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Vehicle Year',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'year',
                        }),
                    },
                    {
                      type: 'text',
                      label: 'Vehicle Make',
                      render: ({ navigation }) =>
                        checkField({
                          navigation,
                          fieldName: 'make',
                        }),
                    },
                  ],
                },
              ],
            },
          ],
        }}
        {...props}
      />
    </View>
  );
};
export default PrintReport;
